import { createSlice } from '@reduxjs/toolkit';
const initState = {
  userInfo: {},
  auth: false,
  examStatusCode: null,
  profileTrackerCode: null,
  userDetails: [],
  previnsurerdetails: [],
  prevrto: '',
};

export const userSlice = createSlice({
  name: 'user',
  initialState: initState,
  reducers: {
    SET_IS_AUTH: (state = initState, action) => {
      const { payload } = action;
      state.auth = payload;
      // return {
      //   ...state,
      //   auth: payload,
      // };
    },
    SET_EXAM_ELIGIBILITY: (state, action) => {
      const { payload } = action;
      state.examStatusCode = payload;
      //   return {
      //     ...state,
      //     examStatusCode: payload,
      //   };
    },

    SET_PROFILE_CODE: (state, action) => {
      const { payload } = action;
      state.profileTrackerCode = payload;
      // return {
      //   ...state,
      //   profileTrackerCode: payload,
      // };
    },
    UPDATE_USER: (state, action) => {
      const { payload } = action;
      state.userInfo = payload;
    },
    UPDATE_USERDETAILS: (state, action) => {
      const { payload } = action;
      state.userDetails = payload;
    },
    UPDATE_PrevInsurer: (state, action) => {
      const { payload } = action;
      state.previnsurerdetails = payload;
    },
    PREV_RTO: (state, action) => {
      const { payload } = action;
      state.prevrto = payload;
    },
  },
});

export const {
  SET_IS_AUTH,
  SET_EXAM_ELIGIBILITY,
  SET_PROFILE_CODE,
  UPDATE_USER,
  UPDATE_USERDETAILS,
  UPDATE_PrevInsurer,
  PREV_RTO,
} = userSlice.actions;

export default userSlice.reducer;
